var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 3.33301H23.3327L33.3327 13.333V33.333C33.3327 35.1663 31.8327 36.6663 29.9993 36.6663H9.98268C8.14935 36.6663 6.66602 35.1663 6.66602 33.333L6.68268 6.66634C6.68268 4.83301 8.16602 3.33301 9.99935 3.33301ZM21.666 5.83301V13.333H29.166L21.666 5.83301ZM13.3327 13.333C12.4122 13.333 11.666 14.0792 11.666 14.9997C11.666 15.9201 12.4122 16.6663 13.3327 16.6663H16.666C17.5865 16.6663 18.3327 15.9201 18.3327 14.9997C18.3327 14.0792 17.5865 13.333 16.666 13.333H13.3327ZM13.3327 19.9997C12.4122 19.9997 11.666 20.7459 11.666 21.6663C11.666 22.5868 12.4122 23.333 13.3327 23.333H26.666C27.5865 23.333 28.3327 22.5868 28.3327 21.6663C28.3327 20.7459 27.5865 19.9997 26.666 19.9997H13.3327ZM13.3327 26.6663C12.4122 26.6663 11.666 27.4125 11.666 28.333C11.666 29.2535 12.4122 29.9997 13.3327 29.9997H26.666C27.5865 29.9997 28.3327 29.2535 28.3327 28.333C28.3327 27.4125 27.5865 26.6663 26.666 26.6663H13.3327Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDoc);
export default __webpack_public_path__ + "static/media/file_doc.8ace7cac.svg";
export { ForwardRef as ReactComponent };